/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type WorkOrderVehicleSdsProvidersQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
}>

export type WorkOrderVehicleSdsProvidersQuery = {
  __typename?: 'Query'
  vehiclesByIDs: Array<{
    __typename?: 'Vehicle'
    id: string
    sdsProvider: Types.SdsProvider
  }>
}

export const WorkOrderVehicleSdsProvidersDocument = gql`
    query WorkOrderVehicleSdsProviders($ids: [ID!]!) {
  vehiclesByIDs(ids: $ids) {
    id
    sdsProvider
  }
}
    `

/**
 * __useWorkOrderVehicleSdsProvidersQuery__
 *
 * To run a query within a React component, call `useWorkOrderVehicleSdsProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderVehicleSdsProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrderVehicleSdsProvidersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useWorkOrderVehicleSdsProvidersQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkOrderVehicleSdsProvidersQuery,
    WorkOrderVehicleSdsProvidersQueryVariables
  > &
    (
      | {
          variables: WorkOrderVehicleSdsProvidersQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    WorkOrderVehicleSdsProvidersQuery,
    WorkOrderVehicleSdsProvidersQueryVariables
  >(WorkOrderVehicleSdsProvidersDocument, options)
}
export function useWorkOrderVehicleSdsProvidersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkOrderVehicleSdsProvidersQuery,
    WorkOrderVehicleSdsProvidersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    WorkOrderVehicleSdsProvidersQuery,
    WorkOrderVehicleSdsProvidersQueryVariables
  >(WorkOrderVehicleSdsProvidersDocument, options)
}
// @ts-ignore
export function useWorkOrderVehicleSdsProvidersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkOrderVehicleSdsProvidersQuery,
    WorkOrderVehicleSdsProvidersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkOrderVehicleSdsProvidersQuery,
  WorkOrderVehicleSdsProvidersQueryVariables
>
export function useWorkOrderVehicleSdsProvidersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkOrderVehicleSdsProvidersQuery,
        WorkOrderVehicleSdsProvidersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkOrderVehicleSdsProvidersQuery | undefined,
  WorkOrderVehicleSdsProvidersQueryVariables
>
export function useWorkOrderVehicleSdsProvidersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkOrderVehicleSdsProvidersQuery,
        WorkOrderVehicleSdsProvidersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    WorkOrderVehicleSdsProvidersQuery,
    WorkOrderVehicleSdsProvidersQueryVariables
  >(WorkOrderVehicleSdsProvidersDocument, options)
}
export type WorkOrderVehicleSdsProvidersQueryHookResult = ReturnType<
  typeof useWorkOrderVehicleSdsProvidersQuery
>
export type WorkOrderVehicleSdsProvidersLazyQueryHookResult = ReturnType<
  typeof useWorkOrderVehicleSdsProvidersLazyQuery
>
export type WorkOrderVehicleSdsProvidersSuspenseQueryHookResult = ReturnType<
  typeof useWorkOrderVehicleSdsProvidersSuspenseQuery
>
export type WorkOrderVehicleSdsProvidersQueryResult = Apollo.QueryResult<
  WorkOrderVehicleSdsProvidersQuery,
  WorkOrderVehicleSdsProvidersQueryVariables
>
